import React from 'react';
import { Inbox, AlertCircle } from 'lucide-react';
import { cn } from '../../utils/cn';

export function EmptyState({ icon, title = 'Rien à afficher', description, action, className, ...rest }) {
  const Icon = icon || Inbox;
  return (
    <div className={cn('flex flex-col items-center justify-center text-center py-12 px-6 border-2 border-dashed border-border rounded-lg bg-bg-2/30', className)} {...rest}>
      <div className="w-12 h-12 rounded-full bg-bg-2 flex items-center justify-center text-mute mb-4">
        {React.isValidElement(icon) ? icon : <Icon className="w-5 h-5" strokeWidth={1.6} />}
      </div>
      <h3 className="text-base font-bold tracking-tight text-text">{title}</h3>
      {description && <p className="text-sm text-mute mt-1.5 max-w-sm leading-relaxed">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorState({ title = 'Une erreur est survenue', description, action, className, ...rest }) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center py-12 px-6 border-2 border-dashed border-danger/30 bg-danger-bg/30 rounded-lg', className)} {...rest}>
      <div className="w-12 h-12 rounded-full bg-danger-bg flex items-center justify-center text-danger mb-4">
        <AlertCircle className="w-5 h-5" strokeWidth={1.8} />
      </div>
      <h3 className="text-base font-bold tracking-tight text-text">{title}</h3>
      {description && <p className="text-sm text-mute mt-1.5 max-w-sm leading-relaxed">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export default EmptyState;
